import { useEffect, useState } from 'react'

export const CREDIT_NOTE_DEBOUNCE_MS = 400

/**
 * The "Credit note contains" box: `draft` is what's typed, `applied` is what
 * the grid filters by. Typed text applies (trimmed) once typing pauses and
 * calls `onApply`, which the table uses to reset `page`. `clear` empties both
 * at once, for Clear all and "No explicit credit".
 */
export const useCreditNoteSearch = (initial: string, onApply: () => void) => {
  const [draft, setDraft] = useState(initial)
  const [applied, setApplied] = useState(initial)

  useEffect(() => {
    const next = draft.trim()
    if (next === applied) return undefined
    const timer = setTimeout(() => {
      setApplied(next)
      onApply()
    }, CREDIT_NOTE_DEBOUNCE_MS)
    return () => clearTimeout(timer)
    // Keyed on typing only. `clear` empties draft and applied together, so the
    // re-run it causes sees nothing to apply and its cleanup drops any pending
    // timer, which means stale text can't come back after a clear.
  }, [draft])

  const clear = () => {
    setDraft('')
    setApplied('')
  }

  return { draft, setDraft, applied, clear }
}
